import searchParameters from "@fartherfinance/frontend/api/TaskWorkflows/requests/searchParameters";
import type { FieldParameter } from "@fartherfinance/frontend/api/TaskWorkflows/Types";
import type { AdvisorRequestConfig } from "@fartherfinance/frontend/api/Types";

import { buildBatchFieldSearchParameters } from "./searchParametersBuilder";

import type { UseFormGetValues } from "react-hook-form";

export const batchSearchParameters = async (
  fieldParameters: FieldParameter[],
  auth: AdvisorRequestConfig | null,
  getValues?: UseFormGetValues<Record<string, unknown>>
) => {
  if (!auth) {
    throw new Error("Authorization is required for batch search parameters");
  }

  if (!fieldParameters || fieldParameters.length === 0) {
    return { data: {} };
  }

  const fields = buildBatchFieldSearchParameters(fieldParameters, getValues);

  if (Object.keys(fields).length === 0) {
    return { data: {} };
  }

  return searchParameters({ fields }, auth);
};
